// Copyright (c) 2016 Deere & Company

import Criteria, {getDefaultState} from '../../basic-warranty-estimator/state/criteria';
import actions from '../../actions-list';

const updateProductPinCriteria = (state, action) =>
    Criteria.update(state, {
        pin: {
            $set: action.pin
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_BASIC_WARRANTY_ESTIMATOR_PIN_CRITERIA]: updateProductPinCriteria
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/basic-warranty-estimator/reducers/criteria.js